import { Link } from "react-router-dom";
import { ArrowUpRight, PhoneCall, CheckCircle2 } from "lucide-react";
import { COMPANY } from "@/lib/company";
import QuickDemoDialog from "@/components/QuickDemoDialog";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative overflow-hidden border-b border-slate-200">
      <div className="absolute inset-0 grid-bg opacity-70 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10 py-16 md:py-24 lg:py-28 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 border border-slate-300 px-3 py-1.5 text-[11px] uppercase tracking-widerest font-mono-plex text-slate-700">
            <span className="h-1.5 w-1.5 bg-[#0052FF] inline-block" />
            {COMPANY.yearsInBusiness} years — Salesforce · AWS · Mulesoft · IBM · AI
          </div>
          <h1 className="mt-6 font-display font-bold tracking-tighter leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-slate-950">
            Train in the tech that <span className="text-[#0052FF]">actually hires</span> in 2026.
          </h1>
          <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed max-w-2xl">
            HCS Computers AI coaches students, working professionals and career switchers into certified roles across
            Salesforce, AWS, Mulesoft, and IBM — with hands-on projects, resume rewrites and interview drills that close offers.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3 max-w-xl">
            {[
              "Live cohorts — weekend friendly",
              "Certification-aligned curriculum",
              "1:1 resume + mock interviews",
              "Fees from INR 19,999 + GST / USD 499",
            ].map((f) => (
              <li key={f} className="flex items-center gap-2 text-sm text-slate-700">
                <CheckCircle2 className="w-4 h-4 text-[#0052FF] shrink-0" />
                {f}
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <Link
              to="/pay-demo"
              data-testid="hero-pay-demo-btn"
              className="inline-flex items-center gap-2 bg-[#0052FF] hover:bg-[#0040CC] text-white font-medium px-6 py-3.5 transition-colors"
            >
              Pay ₹500 & book demo
              <ArrowUpRight className="w-4 h-4" />
            </Link>
            <QuickDemoDialog testIdPrefix="hero-quick-demo">
              <button
                type="button"
                data-testid="hero-contact-demo-btn"
                className="inline-flex items-center gap-2 border border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white font-medium px-6 py-3.5 transition-colors"
              >
                Contact for demo/pricing
              </button>
            </QuickDemoDialog>
            <Link
              to="/courses"
              data-testid="hero-view-courses-btn"
              className="inline-flex items-center gap-2 text-slate-800 hover:text-[#0052FF] font-medium px-2 py-3.5 transition-colors underline underline-offset-4"
            >
              View all courses
            </Link>
            <a
              href={`tel:${COMPANY.phoneDialable}`}
              data-testid="hero-phone-link"
              className="inline-flex items-center gap-2 text-sm text-slate-700 hover:text-slate-950 px-2 py-2"
            >
              <PhoneCall className="w-4 h-4" />
              {COMPANY.phone}
            </a>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-3 border border-slate-200 pointer-events-none" />
            <img
              src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0"
              alt="Corporate IT training class"
              className="relative w-full h-[420px] md:h-[480px] object-cover"
            />
            <div className="absolute left-6 bottom-6 bg-white border border-slate-200 p-4 shadow-lg max-w-[240px]">
              <div className="text-xs uppercase tracking-widerest font-mono-plex text-slate-500">Placement rate</div>
              <div className="mt-1 font-display font-bold text-3xl text-slate-950">87%</div>
              <div className="text-xs text-slate-600 mt-1">alumni placed within 4 months of certification*</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
